import React, { useEffect } from "react";
import { useAuth } from "../../Common/Hooks/useAuth";
import { useNavigate, useLocation } from "react-router-dom";

interface EnsureNotLoggedProps {
  children: React.ReactNode;
}

export const EnsureNotLogged: React.FC<EnsureNotLoggedProps> = ({
  children,
}) => {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn && location.pathname !== "/reset-password") {
      navigate("/");
    }
  }, [isLoggedIn, location.pathname]);

  return children;
};
